import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const createMasterPT = (data) => {
  return httpClient.post(server.MASTERPT, data);
};

export const createMasterPT_V2 = (data) => {
  return httpClient.post(server.MASTERPT + `/create_v2`, data);
};
export const upload_cer = (masterpt_id, data) => {
  return httpClient.post(server.MASTERPT + `/upload_cer/${masterpt_id}`, data);
};
export const update_cer_edit = (masterpt_id, data) => {
  return httpClient.post(
    server.MASTERPT + `/update_cer_edit/${masterpt_id}`,
    data
  );
};

export const getAllMasterPT = () => {
  return httpClient.get(server.MASTERPT + `/getAllSQL`);
};
export const printPT = (masterpt_id) => {
  return httpClient.get(server.MASTERPT + `/printpt/${masterpt_id}`);
};
export const getAllMasterPTLimit200 = () => {
  return httpClient.get(server.MASTERPT + `/getAllLimitSQL200`);
};

export const getByIdMasterPT = (id) => {
  return httpClient.get(server.MASTERPT + `/getById/${id}`);
};

export const getMasterPTFileNoSearch = (searchapplication_no) => {
  return httpClient.get(
    server.MASTERPT + `/getapplication_no/${searchapplication_no}`
  );
};

export const updateMasterPt = (masterpt_id, data) => {
  return httpClient.put(server.MASTERPT + `/${masterpt_id}`, data);
};

export const updateMasterPt_V2 = (masterpt_id, data) => {
  return httpClient.put(server.MASTERPT + `/update_v2/${masterpt_id}`, data);
};
export const updateCloseApp = (file_no) => {
  return httpClient.get(server.MASTERPT + `/status-closed/${file_no}`);
};

export const getMasterPTSearch = (query) => {
  return httpClient.get(server.MASTERPT + `/searchdata`, query);
};
export const getAppNpCheck = (query) => {
  return httpClient.get(server.MASTERPT + `/getAppNpCheck`, query);
};

export const getfile_noPT = (searchfile_no) => {
  return httpClient.get(server.MASTERPT + `/getfile_no/${searchfile_no}`);
};
export const getfile_noPTPayment = (searchfile_no) => {
  return httpClient.get(server.MASTERPT + `/getfile_no-payment/${searchfile_no}`);
};

export const gettimelinemasterpt = (data) => {
  return httpClient.post(server.MASTERPT + `/gettimelinemasterpt`, data);
};

export const getmasterptAllrecords = (data) => {
  return httpClient.post(server.MASTERPT + `/getmasterptAllrecords`, data);
};

// Parameters:getMasterPTSearchPagination
// - page (optional): หน้าที่ต้องการ (default: 1)
// - limit (optional): จำนวนรายการต่อหน้า (default: 10)
// - sortBy (optional): คอลัมน์ที่ต้องการเรียง (default: next_annuity_date)
// - sortOrder (optional): ลำดับการเรียง asc/desc (default: desc)
// - search_pt (optional): คำค้นหา
//   - master_status(optional): สถานะ

export const getMasterPTSearchPagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  search_pt,
  master_status,
  searchdatefrom,
  searchdateto
) => {
  return httpClient.get(server.MASTERPT + `/searchdatapagination`, {
    params: {
      page,
      limit,
      sortBy,
      sortOrder,
      search_pt,
      master_status,
      searchdatefrom,
      searchdateto
    },
  });
};
